/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  AutoComplete,
  Button,
  Col,
  Divider,
  Input,
  Row,
  // Select,
  Modal,
  Table,
  Tooltip,
  Typography,
  Switch,
  Skeleton,
  Badge,
  // DatePicker,
  // Dropdown,
  // Popover,
} from "antd";
import {
  SettingOutlined,
  // SearchOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  // FileTextOutlined,
  // DownOutlined,
  // FileExcelOutlined,
} from "@ant-design/icons";
import "./index.css";
import { Prompt, useHistory } from "react-router";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import { salesHeaders } from "./data";
// import { salesHeaders, items } from "./data";
import useBeforeUnload from "../../components/Prompting";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteSalesInvoiceList,
  loadSalesInvoice,
  loadSalesTotal,
  // loadTotalPaid,
  // loadTotalUnPaid,
} from "../../store/sales-return/actions";
// import { BiRightArrowAlt } from "react-icons/bi";
// import { BiCalendar, BiRightArrowAlt } from "react-icons/bi";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import useMedia from "use-media-antd-query";
import { loadPrefixSettingsList } from "../../store/expenses/actions";
import api from "../../helpers";

const SalesReturn = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  // const { RangePicker } = DatePicker;

  //state initial
  const [salesTab, setSalesTab] = useState("");
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [search, setSearch] = useState("");

  //organisation id from login response

  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const organizationId = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const userId = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";

  const salesInvoiceList = { organizationId: organizationId };
  const salesPrefixList = {
    organizationId: organizationId,
    isType: "isSalesReturn",
  };

  //api loader
  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setLoading(false);
      setTableLoading(false);
    }, 2000);
    dispatch(loadSalesInvoice(salesInvoiceList));
    dispatch(loadSalesTotal(salesInvoiceList));
    // dispatch(loadTotalPaid(salesInvoiceList));
    // dispatch(loadTotalUnPaid(salesInvoiceList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const {
    sales_invoice_list = [],
    sales_total_list = [],
    // total_paid_list = [],
    // total_unpaid_list = [],
  } = useSelector((state) => state.SalesReturn);
  const { prefix_settings_list = [] } = useSelector((state) => state.Expenses);

  //States data
  const [invoiceShow, setInvoiceShow] = useState(false);
  const [prefixValidations, setPrefixValidations] = useState(false);
  const [salesReturnData, setSalesReturnData] = useState({
    prefix: "",
    seqNo: "",
  });

  const media = useMedia();
  const handleChange = (e) => {
    setSalesReturnData({
      ...salesReturnData,
      [e.target.name]: e.target.value,
    });
  };

  // const [searchOpen, setSearchOpen] = useState(false);

  //Custom Fields State values
  const [settingsFieldModal, setSettingsFieldModal] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const handleCancel = () => {
    setSettingsFieldModal(false);
  };

  //header columns
  const HeaderData = [
    {
      key: "salesinvoiceDate",
      title: <p className="header-sales-invoice font-semibold">Date</p>,
      dataIndex: "salesinvoiceDate",
      width: 140,
      // fixed: "left",
      sorter: (a, b) => a.salesinvoiceDate.length - b.salesinvoiceDate.length,
    },
    {
      key: "salesinvoiceNo",
      title: (
        <p className="header-sales-invoice font-semibold">Invoice Number</p>
      ),
      dataIndex: "salesinvoiceNo",
      width: 150,
    },

    {
      key: "partyName",
      title: <p className="header-sales-invoice font-semibold">Party Name</p>,
      dataIndex: "partyName",
      width: 150,
    },
    // {
    //   key: "dueIn",
    //   title: <p className="header-sales-invoice font-semibold">Due In</p>,
    //   dataIndex: "dueIn",
    //   width: 120,
    // },
    {
      key: "returnbillNo",
      title: (
        <p className="header-sales-invoice font-semibold">Return bill No</p>
      ),
      dataIndex: "returnbillNo",
      width: 150,
    },
    {
      key: "billStatus",
      title: <p className="header-sales-invoice font-semibold">Bill Status</p>,
      dataIndex: "billStatus",
      width: 150,
    },
    {
      key: "netTotalAmount",
      title: <p className="header-sales-invoice font-semibold">Amount</p>,
      dataIndex: "netTotalAmount",
      width: 120,
    },
    {
      key: "status",
      title: <p className="header-sales-invoice font-semibold">Status</p>,
      dataIndex: "status",
      width: 120,
    },
  ];

  const salesInvoiceRoutes = (data) => {
    history.push({
      pathname: "/sales-return/data",
      state: {
        salesInvoice: data,
        paid: sales_total_list.totalPaidAmount,
        unpaid: sales_total_list.totalUnPaidAmount,
      },
    });
  };

  //purchase rows

  const [salesReturnRows, setSalesReturnRows] = useState([
    {
      _id: "",
      key: "",
      netTotalAmount: "",
      amountreceivedmode: "",
      balanceAmount: "",
      amountreceived: "",
      authorizedsignature: "",
      autoamountroundoff: "",
      beforeautoroundoffamount: "",
      charge: "",
      createdAt: "",
      createdBy: "",
      financialyearId: "",
      isHistory: "",
      items: "",
      notes: "",
      organizationId: "",
      // amount: "",
      salesinvoiceNo: "",
      salesinvoiceDate: "",
      returnbillNo: "",
      siId: "",
      partyId: "",
      partyAddress: "",
      status: "",
      subtotalamount: "",
      taxableAmonut: "",
      termsandconditions: "",
      totaltax: "",
      totaltaxableValue: "",
      transActionType: "",
      type: "",
      billStatus: "",
      updatedAt: "",
      vendorAddress: "",
      vendorCity: "",
      // partyId: "",
      partyName: "",
      partyNameValue: "",
    },
  ]);

  //data table
  const salesReturnDataTable =
    sales_invoice_list && sales_invoice_list.length > 0
      ? sales_invoice_list.map((data, index) => {
          return {
            _id: data._id,
            key: index + 1,
            returnbillNo: data.returnbillNo,
            siId: data.siId,
            netTotalAmount: (
              <div className="flex">
                <p>{"₹ "}</p>
                <h1
                  className="cursor-pointer ml-1 header-sales-invoice"
                  onClick={() => salesInvoiceRoutes(data)}
                >
                  {data.netTotalAmount.toLocaleString("en-IN")}
                </h1>
              </div>
            ),
            salesinvoiceNo: (
              <h1
                className="cursor-pointer header-sales-invoice"
                onClick={() => salesInvoiceRoutes(data)}
              >
                {data.returnsalesinvoiceNo}
              </h1>
            ),
            salesinvoiceDate: (
              <h1
                className="cursor-pointer header-sales-invoice"
                onClick={() => salesInvoiceRoutes(data)}
              >
                {data.returnsalesinvoiceDate
                  ? moment(data.returnsalesinvoiceDate).format("DD-MM-YYYY")
                  : "--"}
              </h1>
            ),
            authorizedsignature: data.authorizedsignature,
            autoamountroundoff: data.autoamountroundoff,
            beforeautoroundoffamount: data.beforeautoroundoffamount,
            charge: data.charge,
            createdAt: data.createdAt
              ? moment(data.createdAt).format("DD-MM-YYYY")
              : "",
            createdBy: data.createdBy,
            financialyearId: data.financialyearId,
            isHistory: data.isHistory,
            // partyId: data.partyId,
            items: data.items,
            notes: data.notes,
            organizationId: data.organizationId,
            partyAddress: data.partyAddress,
            subtotalamount: data.subtotalamount,
            taxableAmonut: data.taxableAmonut,
            balanceAmount: data.balanceAmount,
            amountreceivedmode: data.amountreceivedmode,
            amountreceived: data.amountreceived,
            termsandconditions: data.termsandconditions,
            totaltax: data.totaltax,
            totaltaxableValue: data.totaltaxableValue,
            transActionType: data.transActionType,
            type: data.type,
            updatedAt: data.updatedAt,
            vendorAddress: data.vendorAddress,
            vendorCity: data.vendorCity,
            // billStatus: data.billStatus,
            partyId: data.partyId,
            partyName: (
              <h1
                className="cursor-pointer capitalize header-sales-invoice"
                onClick={() => salesInvoiceRoutes(data)}
              >
                {data.partyName}
              </h1>
            ),
            partyNameValue: data.partyName,
            status: (
              <Badge
                className={
                  data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusName === "Active"
                    ? "bg-[#edf6ef] font-semibold header-sales-invoice rounded-md text-[#49a563] text-[12px] p-2"
                    : "bg-[#f1e7e9] font-semibold header-sales-invoice rounded-md text-[#d01717] text-[12px] p-2"
                }
                onClick={() => salesInvoiceRoutes(data)}
              >
                {data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusName}
              </Badge>
            ),
            billStatus: (
              <Badge
                className={
                  data.billStatus &&
                  data.billStatus.length > 0 &&
                  data.billStatus[0].billStatusNo === 1
                    ? "bg-[#edf6ef] font-semibold header-sales-invoice rounded-md text-[#49a563] text-[12px] p-2"
                    : "bg-[#f1e7e9] font-semibold header-sales-invoice rounded-md text-[#d01717] text-[12px] p-2"
                }
                onClick={() => salesInvoiceRoutes(data)}
              >
                {data.billStatus &&
                  data.billStatus.length > 0 &&
                  data.billStatus[0].statusName}
              </Badge>
            ),
          };
        })
      : [];

  useEffect(() => {
    if (salesReturnDataTable && salesReturnDataTable.length > 0) {
      setSalesReturnRows(salesReturnDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sales_invoice_list]);

  //expand row
  const expandColumns = [
    {
      title: <p className="header-expand-purchase-invoice">Model</p>,
      dataIndex: "modelName",
      key: "modelName",
    },
    {
      title: <p className="header-expand-purchase-invoice">Barcode</p>,
      dataIndex: "barcode",
      key: "barcode",
    },
    {
      title: <p className="header-expand-purchase-invoice">IMEI</p>,
      key: "IMEI",
      dataIndex: "IMEI",
    },
    {
      title: <p className="header-expand-purchase-invoice">Grade Name</p>,
      dataIndex: "gradeName",
      key: "gradeName",
    },
    {
      title: <p className="header-expand-purchase-invoice">Quantity</p>,
      key: "qty",
      dataIndex: "qty",
    },
    {
      title: <p className="header-expand-purchase-invoice">Purchase Price</p>,
      dataIndex: "totalAmount",
      key: "totalAmount",
    },
    {
      title: <p className="header-expand-purchase-invoice">Selling Price</p>,
      dataIndex: "sellingPrice",
      key: "sellingPrice",
    },
  ];

  const expandedRowRender = (row) => {
    const expandRowData =
      row && row.items.length > 0
        ? row.items.map((data) => {
            const serialDetails =
              data.serialDetails && data.serialDetails.length > 0
                ? data.serialDetails[0]
                : "";
            return {
              modelName: data.modelName ? data.modelName : "--",
              gradeName: serialDetails ? serialDetails.gradeName : "--",
              qty: data ? data.qty : "--",
              barcode: serialDetails ? serialDetails.barCodeNo : "--",
              IMEI: serialDetails ? serialDetails.IMEI : "--",
              totalAmount: serialDetails
                ? serialDetails.totalAmount.toLocaleString("en-IN")
                : "--",
              sellingPrice: serialDetails
                ? serialDetails.sellingPrice.toLocaleString("en-IN")
                : "--",
            };
          })
        : [];
    return (
      <Table
        columns={expandColumns}
        dataSource={expandRowData}
        pagination={false}
        rowClassName={"header-expand-purchase-invoice-column"}
      />
    );
  };

  //data table
  const hasSelected = selectedRowKeys.length > 0;

  const handleSearch = (event) => {
    const filteredRows = salesReturnDataTable
      .filter((row) =>
        row.partyNameValue
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setSalesReturnRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  const [deleteSalesInvoiceModal, setDeleteSalesInvoiceModal] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  //deletPurchase api integrations
  const deleteSalesInvoiceApi = () => {
    setIsButtonDisabled(true);
    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 4000);
    const itemListData = {
      organizationId: organizationId,
      riId:
        selectedRowKeys.length > 0 ? selectedRowKeys.map((data) => data) : "",
      deletedBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
    };
    dispatch(deleteSalesInvoiceList(itemListData));
    setTimeout(() => {
      toast.error("Sales Return deleted successfully");
      dispatch(loadSalesInvoice(salesInvoiceList));
      setDeleteSalesInvoiceModal(false);
      setSelectedRowKeys([]);
    }, 1000);
  };

  //Prefix settings list
  const createPrefixSettings = () => {
    if (salesReturnData.prefix && salesReturnData.seqNo) {
      const prefixList = {
        organizationId: organizationId,
        prefix: salesReturnData.prefix,
        sequenceNo: salesReturnData.seqNo,
        isEnable: invoiceShow ? true : false,
        isType: "isSalesReturn",
        createdBy: userId,
      };
      api
        .post("/org/addnewsequenceno", prefixList)
        .then((res) => {
          dispatch(loadPrefixSettingsList(salesPrefixList));
          toast.success("Prefix updated successfully");
          setSettingsFieldModal(false);
          setPrefixValidations(false);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          toast.error(errorMsg || "there is an issue while adding prefix");
          return Promise.reject(error);
        });
    } else {
      setSettingsFieldModal(true);
      setPrefixValidations(true);
    }
  };

  //prefix setting value listed

  useEffect(() => {
    if (prefix_settings_list && prefix_settings_list.isEnable === true) {
      setSalesReturnData({
        ...salesReturnData,
        prefix: prefix_settings_list.lastprefixName,
        seqNo: prefix_settings_list.lastsequenceNo,
      });
      setInvoiceShow(true);
    } else {
      setSalesReturnData({
        ...salesReturnData,
        prefix: "",
        seqNo: "",
      });
      setInvoiceShow(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefix_settings_list]);

  //page load without saving

  useBeforeUnload({
    when: !isEmpty(search),
    message: "Are you sure you want to leave?",
  });
  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //import invoice
  // const bulkActions = (
  //   <div>
  //     <div
  //       onClick={() => {
  //         history.push({
  //           pathname: "/sales-return/import",
  //           state: { mode: "IMEI" },
  //         });
  //       }}
  //       className="hover:rounded-md hover:bg-[lightgray] hover:mr-[-3px] flex justify-between w-[270px] h-[45px] mt-[2px] pl-3 pr-2 pt-2 pb-12 cursor-pointer"
  //     >
  //       <div>
  //         <p className="flex text-[14px] font-semibold">
  //           <FileExcelOutlined className="mr-2" /> Bulk Import IMEI
  //         </p>
  //         <p className="mt-1 text-[12px]">
  //           Quickly add all your IMEI Details with Excel
  //         </p>
  //       </div>
  //       <BiRightArrowAlt size={24} />
  //     </div>
  //     <div
  //       onClick={() => {
  //         history.push({
  //           pathname: "/sales-return/import",
  //           state: { mode: "Qty" },
  //         });
  //       }}
  //       className="border border-b-0 border-x-0 border-t-1 hover:bg-[lightgray] hover:rounded-md hover:mr-[-3px] flex justify-between w-[270px] h-[55px] mt-[10px] mb-1 pl-3 pr-2 pt-2 pb-8 cursor-pointer"
  //     >
  //       <div>
  //         <p className="flex text-[14px] font-semibold">
  //           <FileExcelOutlined className="mr-2" /> Bulk Import Qty
  //         </p>
  //         <p className="mt-1 text-[12px]">
  //           Quickly add all your qty details with Excel
  //         </p>
  //       </div>
  //       <BiRightArrowAlt size={24} />
  //     </div>
  //   </div>
  // );

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Sales Returns | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-4">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[18px] mt-2 font-semibold"
              >
                Sales Returns
              </h1>
            </div>
            <div className="flex">
              {/* <Dropdown
                menu={{
                  items,
                }}
                trigger={["click"]}
                className="text-[#0c8ce9] rounded-md"
              >
                <Tooltip
                  title="See all your party specific reports"
                  placement="left"
                  rootClassName="text-[10px]"
                >
                  <div
                    style={{
                      border: "1px solid #9ed1f6",

                      fontFamily: "Poppins",
                    }}
                    className="border flex justify-between w-[180px] pl-3 pr-2 pt-2 pb-2 cursor-pointer"
                  >
                    <div>
                      <FileTextOutlined /> Reports
                    </div>
                    <DownOutlined />
                  </div>
                </Tooltip>
              </Dropdown> */}
              <Tooltip
                title="Easily add the Sales Return settings"
                placement="bottom"
                rootClassName="text-[10px]"
              >
                <div
                  onClick={() => {
                    setSettingsFieldModal(true);
                    dispatch(loadPrefixSettingsList(salesPrefixList));
                  }}
                  className="border rounded-md ml-3 pt-2 pb-2 pl-3 pr-3 cursor-pointer"
                >
                  <SettingOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        </Col>
        <div
          className={
            (windowDimensions.height >= 700 &&
              windowDimensions.height <= 767) ||
            (windowDimensions.height > 767 && windowDimensions.height < 830)
              ? "add-sales-home-main-large-device"
              : windowDimensions.height > 830 && windowDimensions.height < 1000
              ? "add-sales-home-extra-main-large-device"
              : windowDimensions.height > 1000
              ? "add-sales-home-main-infinite-large-device"
              : "add-sales-invoices-home-main"
          }
        >
          <Col span={24}>
            <Row className="pl-5 pr-1 mt-5 mb-5">
              {salesHeaders.map((data) => {
                return (
                  <Col span={8} key={data.key} className="">
                    {loading ? (
                      <div className="pr-1">
                        <Skeleton.Input
                          style={{
                            marginRight: "5px",
                            minWidth: "165%",
                            height: "60px",
                          }}
                          active={true}
                          size={"large"}
                          // block={true}
                        ></Skeleton.Input>
                      </div>
                    ) : (
                      <div
                        className={
                          salesTab === data.label
                            ? "poppins mr-4 sales-select-card sales-card border rounded-md"
                            : data.key !== 3
                            ? "poppins mr-4 sales-card border rounded-md"
                            : "poppins sales-select-card sales-card border rounded-md"
                        }
                        onClick={() => setSalesTab(data.label)}
                      >
                        <div
                          style={{
                            fontSize: "14px",
                            display: "flex",
                            fontFamily: "Poppins",
                            color:
                              data.key == 1
                                ? "blue"
                                : data.key == 2
                                ? "#429559"
                                : "#AE1536",
                          }}
                        >
                          <p className={data.key !== 1 ? "mt-[2px]" : ""}>
                            {data.icon}
                          </p>
                          <h2 className={"ml-2 tracking-wide"}>{data.label}</h2>
                        </div>
                        <div className="ml-1 mt-1 flex">
                          <p className="font-semibold text-[18px]">₹ </p>
                          <h1
                            className="font-semibold tracking-wider ml-1 text-[18px]"
                            style={{
                              fontFamily: "Poppins",
                            }}
                          >
                            {data.key == 1
                              ? sales_total_list &&
                                sales_total_list.totalreturnAmount &&
                                sales_total_list.totalreturnAmount.toLocaleString(
                                  "en-IN"
                                )
                              : data.key == 2
                              ? sales_total_list &&
                                sales_total_list.totalPaidAmount &&
                                sales_total_list.totalPaidAmount.toLocaleString(
                                  "en-IN"
                                )
                              : data.key == 3 &&
                                sales_total_list &&
                                sales_total_list.totalUnPaidAmount &&
                                sales_total_list.totalUnPaidAmount.toLocaleString(
                                  "en-IN"
                                )}
                          </h1>
                        </div>
                      </div>
                    )}
                  </Col>
                );
              })}
            </Row>
          </Col>
          {/* purchase input section with bulk actions */}
          <Col span={24} className="sales-invoice-orders mt-1 mb-2">
            <Row className="sales-invoice-filters-main ml-4">
              <div className="sales-invoice-filters">
                {loading ? (
                  <div
                    style={{
                      marginRight: "10px",
                    }}
                  >
                    <Skeleton.Input
                      style={{
                        width: "100%",
                        height: "35px",
                      }}
                    ></Skeleton.Input>
                  </div>
                ) : (
                  <>
                    <Tooltip
                      rootClassName="text-[10px]"
                      title="Search by phone or name"
                      placement="bottom"
                    >
                      {/* {searchOpen ? ( */}
                      <div className="filter-dropdown-filters">
                        <AutoComplete
                          style={{
                            marginRight: "10px",
                            fontSize: "11px",
                          }}
                          // onClick={() => setSearchOpen(false)}
                          className="w-[100%]"
                        >
                          <Input.Search
                            size="middle"
                            placeholder="Search Party"
                            style={{
                              fontFamily: "Poppins",
                              minHeight: "35px",
                              fontSize: "11px",
                            }}
                            name="search"
                            value={search}
                            onChange={(e) => handleSearch(e)}
                          />
                        </AutoComplete>
                      </div>
                      {/* // ) : (
                      //   <div
                      //     onClick={() => setSearchOpen(true)}
                      //     className="filter-dropdown-search-filters border rounded-md h-[40px] mr-3 pt-2 pb-2 pr-3 pl-3 cursor-pointer"
                      //   >
                      //     <SearchOutlined size={16} />
                      //   </div>
                      // )} */}
                    </Tooltip>
                  </>
                )}
                {/* {loading ? (
                  <Skeleton.Input
                    style={{
                      marginRight: "30px",
                      width: "100%",
                      height: "35px",
                    }}
                  ></Skeleton.Input>
                ) : (
                  <div
                    style={{
                      marginLeft: "0.75rem",
                      marginRight: "0.75rem",
                      // marginLeft: searchOpen ? "0.75rem" : "0rem",
                    }}
                    className="filter-dropdown-filters"
                  >
                    <RangePicker
                      style={{
                        width: "100%",
                        height: 35,
                        fontFamily: "Poppins",
                      }}
                      placeholder="Select Days"
                      // value={selectDays}
                      onChange={(date, dateString) => {
                        setSelectDays(dateString);
                      }}
                      options={[]}
                      className="mr-3 text-[11px]"
                      allowClear
                      suffixIcon={<BiCalendar size={14} />}
                    />
                  </div>
                )} */}
              </div>
              <div className="flex">
                {/* {loading ? (
                  <div className="pr-2">
                    <Skeleton.Input
                      style={{
                        marginRight: "5px",
                        width: "100%",
                        height: "35px",
                      }}
                      active={true}
                      size={"large"}
                      // block={true}
                    ></Skeleton.Input>
                  </div>
                ) : (
                  <Popover
                    placement="bottomRight"
                    trigger={"click"}
                    content={bulkActions}
                  >
                    <Tooltip
                      title="Easily perform bulk actions on all your Parties"
                      placement="left"
                      rootClassName="text-[10px]"
                    >
                      <div
                        style={{
                          fontFamily: "Poppins",
                          fontSize: "13px",
                        }}
                        className="border h-[33px] pointer-events-none opacity-1 rounded-sm flex justify-between pl-3 pr-3 pt-1 pb-1 cursor-pointer"
                      >
                        <div className="pr-1 pt-1">
                          <FileTextOutlined /> Bulk Action
                        </div>
                        <DownOutlined className="pt-1" />
                      </div>
                    </Tooltip>
                  </Popover>
                )} */}
                {loading ? (
                  <Skeleton.Input
                    style={{
                      paddingRight: "25px",
                      marginRight: "25px",
                      width: "90%",
                      height: "35px",
                    }}
                  ></Skeleton.Input>
                ) : (
                  <Button
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="ml-3 bg-[blueviolet] p-4 text-[white] mr-4"
                  >
                    <Link
                      to={{
                        pathname: "/create-sales-return",
                        state:
                          sales_invoice_list && sales_invoice_list.length > 0
                            ? sales_invoice_list.length
                            : 1,
                      }}
                    >
                      Create Sales Return
                    </Link>
                  </Button>
                )}
              </div>
            </Row>
          </Col>
          <Col span={24} className="pl-4 pr-4 pb-1">
            {hasSelected ? (
              <Row className="flex justify-between mb-2">
                <Col
                  style={{
                    fontFamily: "Poppins",
                    color: "#ffffff",
                    background: "#4096ff",
                    borderRadius: "10px",
                    padding: "5px 10px",
                  }}
                  className="mb-1"
                  span={4}
                >
                  {hasSelected
                    ? `Selected ${selectedRowKeys.length} items`
                    : ""}
                </Col>
                {selectedRowKeys.length > 0 ? (
                  <Col>
                    <Tooltip title="Delete Sales Return" placement="topLeft">
                      <div
                        onClick={() => setDeleteSalesInvoiceModal(true)}
                        className="cursor-pointer border border-1 p-[8px] rounded-md"
                      >
                        <DeleteOutlined className="text-[#eb4e50] text-[16px]" />
                      </div>
                    </Tooltip>
                  </Col>
                ) : (
                  ""
                )}
              </Row>
            ) : (
              ""
            )}
          </Col>
          <Col
            span={24}
            className={
              media === "xxl"
                ? "pt-14 pr-4 pl-4 sales-invoice-orders"
                : "pt-5 pr-4 pl-4 sales-invoice-orders"
            }
          >
            <Table
              style={{
                overflow: "hidden",
              }}
              bordered
              columns={HeaderData}
              dataSource={
                salesReturnRows &&
                salesReturnRows.length > 0 &&
                !isEmpty(salesReturnRows[0].createdAt)
                  ? salesReturnRows
                  : []
              }
              expandable={{
                expandedRowRender: expandedRowRender,
                defaultExpandAllRows: false,
              }}
              rowKey={(record) => record._id}
              rowClassName={"text-[12px]"}
              pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["5", "10", "20", "30"],
              }}
              sortDirections={"ascend"}
              loading={tableLoading ? true : false}
              showSorterTooltip={"sorter-icon"}
              rowSelection={{
                selectedRowKeys,
                onSelectAll: (selectedRowKeys, selectedRows, row) => {
                  const newSelecteds = selectedRows.map((n) => n._id);
                  setSelectedRowKeys(newSelecteds);
                },
                onSelect: (selectedRowKey, selectedRows, row) => {
                  const selectedIndex = selectedRowKeys.indexOf(
                    selectedRowKey._id
                  );
                  let newSelecteds = [];

                  if (selectedIndex === -1) {
                    newSelecteds = newSelecteds.concat(
                      selectedRowKeys,
                      selectedRowKey._id
                    );
                  } else if (selectedIndex === 0) {
                    newSelecteds = newSelecteds.concat(
                      selectedRowKeys.slice(1)
                    );
                  } else if (selectedIndex === selectedRowKeys.length - 1) {
                    newSelecteds = newSelecteds.concat(
                      selectedRowKeys.slice(0, -1)
                    );
                  } else if (selectedIndex > 0) {
                    newSelecteds = newSelecteds.concat(
                      selectedRowKeys.slice(0, selectedIndex),
                      selectedRowKeys.slice(selectedIndex + 1)
                    );
                  }
                  setSelectedRowKeys(newSelecteds);
                },
              }}
              scroll={{
                y: windowDimensions.height > 500 ? "100%" : "",
                x: 765,
              }}
            />
          </Col>
        </div>
        {/* Custom fields modal */}
        <Modal
          open={settingsFieldModal}
          title="Quick Sales Return Settings"
          onOk={createPrefixSettings}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          onCancel={handleCancel}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
          <Col span={24}>
            <div className="w-[100%] flex justify-between mb-2 mt-[-15px]">
              <h1 className="purchase-label text-[16px]">
                Sales Return Prefix & Invoice Number
              </h1>
              <Switch
                value={invoiceShow}
                onChange={(checked) => setInvoiceShow(checked)}
              />
            </div>
            {invoiceShow ? (
              <Row
                className="mt-2"
                style={{
                  fontFamily: "Poppins",
                }}
              >
                <Col span={8} className="pr-3">
                  <Typography
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="mb-1"
                  >
                    Prefix
                  </Typography>

                  <Input
                    name="prefix"
                    value={salesReturnData.prefix}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Prefix"
                    className="p-2"
                  />
                  {prefixValidations === true &&
                  invoiceShow &&
                  isEmpty(salesReturnData.prefix) ? (
                    <p className="text-[red] text-[12px]">
                      The Prefix field is required
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
                <Col span={8}>
                  <Typography
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="mb-1"
                  >
                    Sequence Number
                  </Typography>

                  <Input
                    name="seqNo"
                    value={salesReturnData.seqNo}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Seq No"
                    className="p-2"
                  />
                  {prefixValidations === true &&
                  invoiceShow &&
                  isEmpty(salesReturnData.seqNo) ? (
                    <p className="text-[red] text-[12px]">
                      The seq no field is required
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
                <Col span={24} className="mt-2">
                  <Typography
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="mb-1"
                  >
                    Sales Return Number:{" "}
                    {salesReturnData.prefix && salesReturnData.seqNo
                      ? salesReturnData.prefix + "" + salesReturnData.seqNo
                      : ""}
                  </Typography>
                </Col>
              </Row>
            ) : (
              ""
            )}
          </Col>

          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>
      </Row>
      {/* Delete purchase modal */}

      <Modal
        open={deleteSalesInvoiceModal}
        onOk={() => {
          deleteSalesInvoiceApi();
        }}
        closeIcon
        maskClosable={false}
        okText={`Delete RI`}
        cancelText={"Cancel"}
        okType="danger"
        okButtonProps={{
          disabled: isButtonDisabled ? true : false,
        }}
        onCancel={() => setDeleteSalesInvoiceModal(false)}
        height={300}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <CancelBtn />
            <div className="ml-3">
              <OkBtn />
            </div>
          </div>
        )}
      >
        <div className="text-center w-[100%] p-7">
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to delete these Sales Return?
          </h1>
          <p className="text-center text-[14px] mt-2">
            The selected Sales Return will be deleted from the Sales Return
            Inventory. Once deleted you will not be able to restore these sales
            invoice.
          </p>
        </div>
      </Modal>
      <Prompt
        when={!isEmpty(search)}
        message="Are you sure you want to leave?"
      />
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

SalesReturn.propTypes = {
  location: PropTypes.any,
};

export default SalesReturn;
